export default "__VITE_ASSET__DvyMWudm__"